module.exports = __webpack_public_path__ + "static/img/3.5042b46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/3.png
// module id = QiPH
// module chunks = 0